import { useState, useContext } from 'react';
import { Context } from 'components/Store';

const useSessionStorage = (key, initialValue) => {
  const [dispatch] = useContext(Context);
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      const valueToStore =
        typeof value === 'function' ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (err) {
      dispatch(err);
    }
  };

  return { storedValue, setValue };
};

export default useSessionStorage;
